<template>
  <div class="page-content"  id="monitoringProducts">
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>监控中心</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/newProductPandect' }">监控产品</el-breadcrumb-item>
      <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
    </el-breadcrumb>
    <section class="seaerch-wrapper">
      <div style="margin: 0 20px 20px 40px;">
        <el-tag type="warning" style="width: 100%;">
          <img src="../../../assets/img/other/trumpet_icon.png" style="margin-left: 13px;margin-right: 5px;">
          <span>当前监控模式为：
            <span v-if="retrieve === '0'">标价</span>
            <span v-if="retrieve === '1'">到手价</span>
            <span v-if="retrieve === '2'">标价&到手价</span>
          </span>
        </el-tag>
      </div>
      <el-form label-width="130px">

        <el-form-item label="计划名称：" :required="true">
          <el-input
            placeholder="请输入"
            v-model="planname"
            size="small"
            clearable
            onkeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
            style="width: 425px;"
          ></el-input>
        </el-form-item>

        <el-form-item label="监控平台：" :required="true">
          <el-select v-model="platform" multiple placeholder="请选择" size="small" style="width: 425px;">
            <el-option
              v-for="item in productmonitorPlatform"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="监控时间：" :required="true">
          <el-select
            size="small"
            v-model="plathour"
            multiple
            placeholder="请选择"
            style="width: 425px;"
            :multiple-limit="limitMonitorTimeNum"
          >
            <el-option
              v-for="item in time"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
          <span style="padding-left: 15px;color: #FAAD14;">
            可设置{{limitMonitorTimeNum}}个监控时间
          </span>
        </el-form-item>

        <el-form-item label="监控产品：" :required="true">
          <div class="addFont" @click="newAdd">
            <i class="el-icon-plus"></i>
            新增监控产品
          </div>
        </el-form-item>
      </el-form>

      <el-button size="small" style="margin-left: 47px;margin-bottom: 8px;" @click="delSure('批量删除')">
        批量删除
      </el-button>
      <span style="padding-left: 15px;color: #FAAD14;">
        可监控产品数量上限：{{chiLdNum}}/{{allLimitProNum}}
      </span>
      <el-table
        @selection-change="handleSelectionChange"
        :data="productsData"
        ref="multipleTable"
        style="padding-left: 47px;padding-bottom: 10px;"
        height="460"
        >
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column label="产品信息" prop="name">
        </el-table-column>
        <el-table-column width="210" label="操作">
          <template slot-scope="scope">
            <div class="g-margin-left" style="color: #108cee;cursor: pointer;">
              <i class="el-icon-delete"></i>
              <span class="g-inline-block" @click="delSure(scope.$index)">删除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <childMonitoring ref="childMonitoring" @selectedfirm="onComfirm" @fatherBlur="inputBlur"/>
      <el-form label-width="130px" style="margin-top: 24px;">
        <el-form-item label="通知人：">
          <el-select v-model="openid" multiple placeholder="请选择" size="small" style="width: 425px;">
            <el-option
              v-for="item in WecharList"
              :key="item.openid"
              :label="item.nickname"
              :value="item.openid">
            </el-option>
          </el-select>
          <el-button type="text" size="small" style="margin-left: 8px;" @click="getbmcwx">新增通知人</el-button>
        </el-form-item>
      </el-form>
      <div style="margin-left: 51px;margin-top: 40px;">
        <el-button size="small" class="g-confirm-btn" @click="save" type="primary" :loading="saveLoading">确 认</el-button>
  			<el-button size="small" class="g-cancel-btn" @click="$router.push(`/newProductPandect`)" type="TheCustom">取 消</el-button>
      </div>
    </section>
  </div>
  <wxBindingComponent ref="childWxBinding"/>
</div>

</template>

<script>
  import childMonitoring from "../../../components/childMonitoring/childMonitoring.vue";
  import wxBindingComponent from "../../../components/wxComponent/wxBindingComponent.vue";
  import { mapActions } from 'vuex';
  export default {
    data() {
      return {
        retrieve: '',
        status: 0,
        title: '新增',
        bid: '',
        wechatUrl: '',
        saveLoading: false,
        multipleSelection:[],
        time:[],
        openid: [],
        planname: '',
        plathour: [],
        platform: [],
        limitMonitorTimeNum: 1,
        allLimitProNum: 0,
        productsData: [],
        WecharList: [],
        faData: [],
        chiLdNum: 0,
        productmonitorPlatform: [],
      }
    },
    mounted() {
      // 获取监控时间监控个数
      console.log(this.$route.query.pushmode)
      this.getProductCount()
      fetch({
  			url: 'hcm/cus/selectbmcSetting'
  		}).then(res => {
  			if(res.status === '10000') {
  				this.limitMonitorTimeNum = res.data.productmonitorFrequency === 1 ? 2 : 1;
          this.allLimitProNum = res.data.productmonitorNumber;
          this.retrieve = res.data.retrieve;
          if (res.data.productmonitorPlatform) {
            let platArr = []
            platArr = res.data.productmonitorPlatform.split(',')
            console.log('可监控平台',platArr)
            for (let a in platArr) {
              if (platArr[a] == 'TB') {
                this.productmonitorPlatform.push({
                  value: platArr[a],
                  label: '淘宝'
                })
              } else if (platArr[a] == 'TM') {
                this.productmonitorPlatform.push({
                  value: platArr[a],
                  label: '天猫'
                })
              } else if (platArr[a] == 'JD') {
                this.productmonitorPlatform.push({
                  value: platArr[a],
                  label: '京东'
                })
              } else if (platArr[a] == 'SN') {
                this.productmonitorPlatform.push({
                  value: platArr[a],
                  label: '苏宁'
                })
              } else if (platArr[a] == 'PDD') {
                this.productmonitorPlatform.push({
                  value: platArr[a],
                  label: '拼多多'
                })
              } else if (platArr[a] == '1688') {
                this.productmonitorPlatform.push({
                  value: platArr[a],
                  label: '1688'
                })
              } else if (platArr[a] == 'DD') {
                this.productmonitorPlatform.push({
                  value: platArr[a],
                  label: '当当'
                })
              }
            }
          }
  			}
  		})
      // 获取监控时间
      this.generateMonitorTime();
      this.getWecharList();
      if (this.$route.query.id) {
        this.title = '编辑'
        this.fatFun()
      }
    },
    methods: {
      // 监控产品数量
      getProductCount() {
        fetch({
    			url: 'hcm/hcmNewMonitorProduct/getProductCount'
    		}).then(res => {
    			if(res.status === '10000') {
            this.totalNum = Number(res.data)
            this.chiLdNum = 0
            this.chiLdNum = this.totalNum + this.productsData.length
    			}
    		})
      },
      // 编辑调用此方法
      fatFun() {
        let params={
          pageNo: this.$route.query.pageNo,
          pageSize: this.$route.query.pageSize,
        }
        fetch({
          url: "hcm/hcmNewMonitorProduct/getPage",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            if (res.data.content.length > 0) {
              for (let a in res.data.content) {
                if (res.data.content[a].id == this.$route.query.id) {
                  this.faData = res.data.content[a]
                }
              }
              if (this.faData.planname) {
                this.planname = this.faData.planname
              }
              if (this.faData.platform) {
                this.platform = this.faData.platform.split(',')
              }
              if (this.faData.plathour) {
                this.plathour = this.faData.plathour.split(',')
              }
              if (this.faData.noticeuserid) {
                this.openid = this.faData.noticeuserid.split(',')
              }
              if (this.faData.status) {
                this.status = this.faData.status
              }
              if (this.faData.childList.length > 0) {
                for (var i = 0; i < this.faData.childList.length; i++) {
                  for (var j = i + 1; j < this.faData.childList.length; j++) {
                    if ( this.faData.childList[i].productid ===  this.faData.childList[j].productid) {
                       this.faData.childList.splice(j, 1);
                      j--;
                    }
                  }
                }
                for (let z in this.faData.childList) {
                  this.productsData.push({
                    productid: this.faData.childList[z].productid,
                    name: this.faData.childList[z].productname,
                    price: 0,
                  })
                }
                console.log(this.productsData)
              }
            }
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        })
      },
      // 获取bid调用微信接口
      getbmcwx() {
        fetch({
          url: "hcm/userout/getbmcwx",
          method: "get",
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.bid = data.data.bid
            this.addWechatPerson()
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        })
      },
      addWechatPerson() {
  			this.$refs.childWxBinding.getbmcwx('m',this.bid)
  		},
      // 生成0 - 24点的时间
      generateMonitorTime() {
  			let res = [];
  			for(let i = 0; i <= 23;i++) {
          if (i <= 9) {
            res.push(`0${i}:00`)
          } else {
            res.push(`${i}:00`)
          }
  			}
  			this.time = res;
  		},
      // 子组件搜索
      inputBlur() {
        console.log('调用')
        this.newAdd()
      },
      // 新增监控产品
      newAdd() {
        let params = {
          pageNum: 1,
          pageSize: 10000,
        }
        fetch({
          url: "hcm/ProductClassify/seletProductClassify",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            // 组件类型
            let typeNum = 1
            this.$refs.childMonitoring.open(typeNum,res.data.data.list,this.productsData,this.allLimitProNum,this.chiLdNum)
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        })
      },
      // 获取微信通知人数据
      getWecharList() {
        fetch({
          url: "hcm/hcmNewMonitorProduct/getWecharList",
          method: "get",
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.WecharList = res.data
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        })
      },
      // 子传父
      onComfirm(data) {
        // 新增监控产品表格数据
        console.log('新增监控产品表格数据')
        this.productsData = data
        this.chiLdNum = 0
        this.chiLdNum = this.totalNum + this.productsData.length
      },
      delSure(index) {
        if (index == '批量删除') {
          if (this.multipleSelection.length === 0) {
            this.$message({
              message: '请选择产品信息',
              type: "error"
            });
            return;
          }
          for (let a in this.multipleSelection) {
            for (let b in this.productsData) {
              if (this.multipleSelection[a] === this.productsData[b]) {
                this.productsData.splice(b,1)
              }
            }
          }
        } else {
          this.productsData.splice(index,1)
        }
        this.chiLdNum = 0
        this.chiLdNum = this.totalNum + this.productsData.length
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      save() {
        if (!this.planname) {
          this.$message({
            message: '请填写计划名称',
            type: 'warning'
          });
          return
        }
        if (this.platform.length == 0) {
          this.$message({
            message: '请选择监控平台',
            type: 'warning'
          });
          return
        }
        if (this.plathour.length == 0) {
          this.$message({
            message: '请选择监控时间',
            type: 'warning'
          });
          return
        }
        if (this.productsData.length == 0) {
          this.$message({
            message: '请添加监控产品',
            type: 'warning'
          });
          return
        }
        this.saveLoading = true
        let allData = []
        for (let b in this.productsData) {
          for (let a in this.platform) {
            allData.push({
              productid: this.productsData[b].productid,
              price: this.productsData[b].price,
              platform: this.platform[a]
            })
          }
        }
        let params = {
          planname: this.planname,
          platform: this.platform.join(','),
          plathour: this.plathour.join(','),
          noticeuserid: this.openid.join(','),
          status: 1,
          pushmode: this.$route.query.pushmode
        }
        if (allData.length > 0) {
          params.childList = allData
        }
        if (this.$route.query.id) {
          params.id = this.$route.query.id
          params.status = this.status
        }
        fetch({
          method: 'POST',
  				url: 'hcm/hcmNewMonitorProduct/save',
  				data: JSON.stringify(params),
  				headers: {
  					'Content-Type': 'application/json'
  				}
        }).then(res => {
          if(res.status == '10000'){
            this.saveLoading = false
            this.$message({
              message: '成功',
              type: 'success'
            });
            // 新增的话数据清空
            if (!this.$route.query.id) {
              this.planname = ''
              this.platform = []
              this.plathour = []
              this.productsData = []
              this.openid= []
            }
            this.$router.push(`/newProductPandect`)
          } else {
            this.$message.error(res.message);
          }
        })
      },
    },
    components: {
      childMonitoring,
      wxBindingComponent
    }
  }
</script>
<style lang="scss">
  #monitoringProducts{
    .el-table__empty-text {
      padding-top: 100px;
      background: url("../../../assets/img/other/nodata.svg") no-repeat;
      background-position: center 66px;
    }
    .el-table th {
      background-color: #f2f6fe !important;
      color: #4a4b4c;
    }

    #dialog {
      .el-button--primary {
        color: #FFF;
        background-color: #bda571;
        border-color: #bda571;
      }
      .el-button--primary:hover {
        color: #FFF;
        background-color: #c0ae8a;
        border-color: #c0ae8a;
      }
    }
    .el-button--TheCustom {
      color: #666;
      border-color: #D9D9D9;
      background-color: #fff;
    }
    .el-button--TheCustom:hover  {
      color: #666;
      border-color: #ded2b8;
      background-color: #faf9f5;
    }
    .addFont {
      color: #108cee;
      font-weight: bold;
      text-align: center;
      border: 1px dashed #e8ebec;
      height: 30px;
      width: 425px;
      line-height: 30px;
      cursor: pointer;
    }
    .addFont:hover {
      border: 1px dashed #108cee;
    }
  }
</style>
